import { isObject } from 'lodash'

/* 本地缓存上一次拖拽宽度的相关内容 */
const HISTORY_WIDTH = 'GLOBAL_COL_HISTORY_WIDTH'
const WIDTH = 'GLOBAL_COL_WIDTH'
export function getHistoryDataByTableKey (tableKey) {
  let res = localStorage.getItem(HISTORY_WIDTH)
  try {
    res = JSON.parse(res)
    res = res[tableKey]
  } catch (e) {
    res = {}
  }
  return res || {}
}

export function setHistoryData (tableKey, data = {}) {
  let res = localStorage.getItem(HISTORY_WIDTH)
  try {
    res = JSON.parse(res) || {}
  } catch (e) {
    res = {}
  }
  res[tableKey] = data
  res = deleteCacheItem(res)
  localStorage.setItem(HISTORY_WIDTH, JSON.stringify(res))
}

export function getUserDataByTableKey (tableKey) {
  let res = localStorage.getItem(WIDTH)
  try {
    res = JSON.parse(res)
    res = res[tableKey]
  } catch (e) {
    res = {}
  }
  return res || {}
}

export function setUserData (tableKey, data = {}) {
  let res = localStorage.getItem(WIDTH)
  try {
    res = JSON.parse(res) || {}
  } catch (e) {
    res = {}
  }
  res[tableKey] = data
  res = deleteCacheItem(res)
  localStorage.setItem(WIDTH, JSON.stringify(res))
}

export function deleteCacheItem (res) {
  const arr = Object.keys(res)
  arr.forEach(tableKey => {
    const fields = Object.keys(res[tableKey])
    if (fields.length === 0) {
      delete res[tableKey]
    }
  })
  return res
}

export function setHistoryDataByDragColumn (tableKey, key, width) {
  let data = getHistoryDataByTableKey(tableKey)
  if (data && (!data.hasOwnProperty(key))) {
    data[key] = width
  }
  setHistoryData(tableKey, data)
}


export function dragHistoryWidthPlugins (vm) {
  try {
    const handleDragHistoryWidthEmitEvent = (width, oldWidth, column) => {
      const { key } = column
      if (!vm.searchCode) {
        return
      }
      let res = localStorage.getItem('GLOBAL_COL_WIDTH')
      let tag = vm.tableKey
      if (res) {
        try {
          res = JSON.parse(res)
          if (res) {
            if (res[tag]) {
              res[tag][key] = width
            } else {
              res[tag] = { [key]: width }
            }
            localStorage.setItem('GLOBAL_COL_WIDTH', JSON.stringify(res))
          }
        } catch (e) {
        }
      } else {
        res = { [tag]: { [key]: width } }
        localStorage.setItem('GLOBAL_COL_WIDTH', JSON.stringify(res))
      }
      setHistoryDataByDragColumn(tag, key, oldWidth)
    }
    vm.$refs.table.$on('header-dragend', handleDragHistoryWidthEmitEvent)
    const destroy = () => {
      vm.$refs.table.$off('header-dragend', handleDragHistoryWidthEmitEvent)
    }
    const getLocalStorePreColumnWidthMap = () => {
      let tag = vm.tableKey
      const preColumnWidthMap = getHistoryDataByTableKey(tag) || {}
      const keys = Object.keys(preColumnWidthMap)
      if (keys.length) {
        const storePreColumnsOpt = keys.reduce((col, k) => {
          col[k] = {
            width: preColumnWidthMap[k]
          }
          return col
        }, {})
        return storePreColumnsOpt
      }
      return {}
    }

    const getLocalStoreUserActionWidthMap = () => {
      let res = localStorage.getItem('GLOBAL_COL_WIDTH')
      if (vm.searchCode && res) {
        try {
          let tag = vm.tableKey
          res = JSON.parse(res)
          if (res && isObject(res)) {
            const obj = res[tag]
            const keys = isObject(obj) ? Object.keys(obj) : []
            if (keys.length) {
              const storeColumnsOpt = keys.reduce((col, k) => {
                col[k] = {
                  width: obj[k]
                }
                return col
              }, {})
              return storeColumnsOpt
            }
          }
          return {}
        } catch (e) {
          const tag = vm.$vnode ? vm.$vnode.tag : ''
          const menuId = vm.$store.state.menus && vm.$store.state.menus[vm.$route.meta.tag] && vm.$store.state.menus[vm.$route.meta.tag].id
          let refArr = vm.$refs
          refArr = refArr ? Object.keys(refArr) : []
          vm.$logReport({
            menuId: menuId || '2820215716730110', // 菜单id
            logId: 'public-drag-width-table2', // 日志id 建议：部门标识 + 编码，方便识别
            log: JSON.stringify(e.message + e.stack), // 日志详情
            ext1: localStorage.getItem('GLOBAL_COL_WIDTH'),
            ext2: localStorage.getItem('GLOBAL_COL_HISTORY_WIDTH'),
            ext3: `refs=${JSON.stringify(refArr)}，tag=${tag}，customTable=${Boolean(vm.tableConfig.option.customTable)}`
          })
          return {}
        }
      } else {
        return {}
      }
    }
    return {
      destroy,
      getLocalStorePreColumnWidthMap,
      getLocalStoreUserActionWidthMap,
      name: 'dragHistoryWidthPlugin'
    }
  } catch (error) {
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/plugins/drag-history-width.js